"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagCK = function FlagCK(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.06,7.06,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.74-122H-7.53L-72.95-79.14V-122h-35.3v42.86L-173.67-122h-12.27a7.06,7.06,0,0,0-7.06,7.06v5.6l56.12,36.77H-193v35.32h56.12L-193-.48v5.6a7.06,7.06,0,0,0,7.06,7.06h12.27l65.42-42.86V12.18h35.3V-30.68L-7.53,12.18H4.74A7.06,7.06,0,0,0,11.8,5.12V-.48L-44.32-37.25H11.8V-72.57H-44.32L11.8-109.34v-5.6A7.06,7.06,0,0,0,4.74-122Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8-65.5H-80V-122H-101.2v56.5H-193v21.18h91.8v56.5H-80v-56.5H11.8Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-115.32-72.57l-74.31-48.23a6.94,6.94,0,0,0-3.37,5.86v.37l64.71,42Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-60-72.57l70.7-45.89a7,7,0,0,0-6-3.54H3.21L-72.95-72.57Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-121.42-37.25-192,8.55a7,7,0,0,0,6,3.63h1.33l76.16-49.43Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.69,5.67-54.45-37.25h-13L7.68,11.49a7,7,0,0,0,4-5.82Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M108.7-72.53l2.59,7.76,8.19.07a.66.66,0,0,1,.38,1.19l-6.58,4.87,2.47,7.8a.66.66,0,0,1-1,.73l-6.66-4.76-6.66,4.76a.65.65,0,0,1-1-.73l2.47-7.8-6.59-4.87a.66.66,0,0,1,.39-1.19l8.19-.07,2.58-7.76a.67.67,0,0,1,1.26,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M73.89-63l5.53,6,7.5-3.27a.66.66,0,0,1,.84.93l-4,7.12L89.15-46a.66.66,0,0,1-.62,1.08l-8-1.64-4.14,7.06a.66.66,0,0,1-1.23-.26l-.92-8.13-8-1.77a.66.66,0,0,1-.13-1.24l7.45-3.39-.79-8.15A.66.66,0,0,1,73.89-63Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M46-40.09l7.5,3.27,5.53-6a.66.66,0,0,1,1.14.5l-.79,8.15,7.45,3.39a.66.66,0,0,1-.13,1.25l-8,1.76-.92,8.13a.66.66,0,0,1-1.23.27l-4.15-7.06-8,1.64a.65.65,0,0,1-.62-1.08L49.18-32l-4-7.12a.66.66,0,0,1,.84-.93Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M29.78-7.83,38-7.89l2.59-7.77a.66.66,0,0,1,1.25,0L44.4-7.89l8.19.06A.66.66,0,0,1,53-6.64L46.39-1.78,48.86,6a.66.66,0,0,1-1,.73L41.18,2,34.52,6.76a.66.66,0,0,1-1-.73L36-1.78,29.39-6.64a.66.66,0,0,1,.39-1.19Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M28.11,28.23l7.45-3.39-.79-8.15a.66.66,0,0,1,1.14-.51l5.53,6L49,19a.66.66,0,0,1,.83.93l-4,7.12,5.43,6.13a.66.66,0,0,1-.62,1.08l-8-1.64-4.15,7.06a.66.66,0,0,1-1.23-.26l-.92-8.14-8-1.76a.66.66,0,0,1-.13-1.24Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M41.25,61.84l5.43-6.12-4-7.12a.66.66,0,0,1,.84-.93L51,50.94l5.53-6a.66.66,0,0,1,1.14.51l-.79,8.14,7.45,3.39a.66.66,0,0,1-.13,1.25l-8,1.76-.92,8.14a.66.66,0,0,1-1.23.26l-4.15-7.06-8,1.64a.66.66,0,0,1-.62-1.09Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M66.93,87.21l2.46-7.8-6.58-4.86a.66.66,0,0,1,.38-1.19l8.19-.07L74,65.53a.67.67,0,0,1,1.26,0l2.58,7.76,8.19.07a.66.66,0,0,1,.39,1.19L79.8,79.41l2.47,7.8a.66.66,0,0,1-1,.74L74.6,83.19,67.93,88a.65.65,0,0,1-1-.74Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M100.7,100l-.91-8.14-8-1.76a.66.66,0,0,1-.13-1.25l7.45-3.38-.79-8.15a.66.66,0,0,1,1.14-.51l5.53,6,7.5-3.27a.66.66,0,0,1,.84.93l-4,7.12,5.43,6.13a.66.66,0,0,1-.62,1.08l-8-1.64-4.14,7.06a.66.66,0,0,1-1.23-.26Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M136.74,97.84l-4.15-7-8,1.64a.66.66,0,0,1-.63-1.09l5.44-6.13-4-7.12a.66.66,0,0,1,.83-.93l7.51,3.27,5.52-6a.66.66,0,0,1,1.14.51l-.79,8.15L147,86.44a.66.66,0,0,1-.13,1.24l-8,1.77L138,97.58a.66.66,0,0,1-1.22.26Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M168.8,81.26l-6.66-4.76-6.66,4.76a.66.66,0,0,1-1-.73l2.47-7.81-6.58-4.86a.66.66,0,0,1,.38-1.19l8.19-.06,2.59-7.77a.66.66,0,0,1,1.26,0l2.59,7.77,8.18.06a.66.66,0,0,1,.39,1.19l-6.59,4.86,2.47,7.81a.66.66,0,0,1-1,.73Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M191.35,53.07l-8-1.64-4.15,7.06a.66.66,0,0,1-1.23-.26L177,50.1l-8-1.77a.66.66,0,0,1-.13-1.24l7.45-3.39-.79-8.15a.66.66,0,0,1,1.14-.51l5.53,6,7.5-3.27a.66.66,0,0,1,.84.93l-4,7.12L192,52a.66.66,0,0,1-.62,1.08Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M200.48,18.15l-8,1.76-.92,8.14a.66.66,0,0,1-1.23.26l-4.14-7.06-8,1.64a.65.65,0,0,1-.62-1.08L183,15.68l-4-7.12a.66.66,0,0,1,.84-.93l7.5,3.27,5.52-6a.66.66,0,0,1,1.15.51l-.79,8.15,7.45,3.39a.66.66,0,0,1-.13,1.24Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M194.62-17.46,188-12.6l2.47,7.8a.66.66,0,0,1-1,.74l-6.66-4.76-6.66,4.76a.66.66,0,0,1-1-.74l2.46-7.8L171-17.46a.67.67,0,0,1,.39-1.2l8.18-.06,2.59-7.77a.66.66,0,0,1,1.25,0L186-18.72l8.19.06a.67.67,0,0,1,.39,1.2Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M174.78-47.62l-4,7.12,5.43,6.13a.66.66,0,0,1-.62,1.08l-8-1.64-4.15,7.06a.66.66,0,0,1-1.22-.26l-.92-8.14-8-1.76a.66.66,0,0,1-.14-1.24l7.46-3.39-.79-8.15a.66.66,0,0,1,1.14-.51l5.53,6,7.5-3.27a.66.66,0,0,1,.84.93Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M144.39-67.1l-.8,8.15,7.46,3.39a.66.66,0,0,1-.13,1.24l-8,1.77L142-44.42a.66.66,0,0,1-1.22.26l-4.15-7.05-8,1.64a.67.67,0,0,1-.63-1.09l5.43-6.13-4-7.12a.66.66,0,0,1,.83-.93l7.51,3.27,5.52-6a.67.67,0,0,1,1.15.51Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M108.7-72.53l2.59,7.76,8.19.07a.66.66,0,0,1,.38,1.19l-6.58,4.87,2.47,7.8a.66.66,0,0,1-1,.73l-6.66-4.76-6.66,4.76a.65.65,0,0,1-1-.73l2.47-7.8-6.59-4.87a.66.66,0,0,1,.39-1.19l8.19-.07,2.58-7.76a.67.67,0,0,1,1.26,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagCK;
exports["default"] = _default;